import React from "react";
import { useTheme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { demos } from './demosData';
import DemoItem from './components/DemoItem';

function Demos() {
    const theme = useTheme();

    return (
        <Box 
          sx={{
            paddingLeft: { xs: 3, md: '15%' },
            paddingTop: '100px',
            minHeight: '100vh',
            background: theme.palette.background.default,
            color: theme.palette.text.primary
          }}
        >
            <Box sx={{ width: '100%', maxWidth: '800px', textAlign: 'left' }}>
                <Typography variant="h2" component="h1" sx={{ mb: 4, fontWeight: 'bold' }}>
                    Demos
                </Typography>
                
                <Box component="ul" sx={{ listStyle: 'none', padding: 0, margin: 0 }}>
                    {demos.map((demo) => (
                        <li key={demo.id} style={{ marginBottom: '12px' }}>
                            <DemoItem demo={demo} />
                        </li>
                    ))}
                </Box>
            </Box>
        </Box>
    );
}

export default Demos;